import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

/* `bleed` lets a page (the home hero) run under the fixed header. */
export default function Layout({ children, bleed = false }) {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:start-3 focus:z-toast focus:rounded-lg focus:bg-[var(--signal)] focus:px-4 focus:py-2 focus:font-bold focus:text-[var(--signal-ink)]"
      >
        Skip to content
      </a>
      <Header />
      <main id="main" className={`flex-1 ${bleed ? "" : "pt-16 lg:pt-[72px]"}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
